export class bookingQueryKeys{
    constructor() {
        this.step = "step";
        this.paymentSuccess = 'paymentSuccess';
        this.onLocation = 'onLocation';
        this.rooms = "rooms";
        this.isNewCustomer = "isNewCustomer";
        this.referrer = "referrer";
        this.minSize = "minSize";
        this.maxSize = "maxSize";
        this.fromRecommendation = "fromRec";
    }
};
export default new bookingQueryKeys();